import { render, staticRenderFns } from "./CustomerCustomerTransaction.vue?vue&type=template&id=734539d4"
import script from "./CustomerCustomerTransaction.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports